import React from 'react';
import { useTranslation } from 'react-i18next';

// import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
// import { makeStyles } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

// import withWidth, { isWidthDown } from '@mui/material/withWidth';
// import { selectLoading, selectLoginForm } from '../selectors';
import LoginForm from './form';
import { useLgStyles, useSmStyles } from './styles';

export function LoginPage() {
  const classesLg = useLgStyles();
  const classesSm = useSmStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const {t} = useTranslation();
  if (matches) {
    return (
      <div className={classesSm.root}>
        <div className={classesSm.banner}>
          <Box className={classesSm.logoWrap}>

          </Box>
          <LoginForm className={classesSm.paper} />
        </div>
      </div>
    );
  }
  return (
    <div className={classesLg.root}>
      <LoginForm className={classesLg.paper} />
      <div className={classesLg.banner}>
        <Box className={classesLg.logoWrap}>

        </Box>
      </div>

    </div>
  );
}

export default LoginPage;
